// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"476d1836","513":"4d1ee5ac","703":"faa3ca04","787":"0abf99fd"}[chunkId] + ".chunk.js";
};